import { Link, useLocation } from 'react-router-dom';
import { SignedIn, SignedOut, UserButton } from '@clerk/clerk-react';
import { IonIcon, useIonRouter } from '@ionic/react';
import { getPageTitle } from '../../utils/getPageTitle';
import { SearchBar } from './SearchBar';
import { NotificationBell } from './NotificationBell';
import hamIcon from '../../assets/ham-icon.svg';
import SellIcon from '@mui/icons-material/Sell';
import { CreditCard } from '@mui/icons-material';

interface DesktopHeaderProps {
  onToggleSidebar: () => void;
  isXL: boolean;
}

export function DesktopHeader({ onToggleSidebar, isXL }: DesktopHeaderProps) {
  const router = useIonRouter();
  const location = useLocation();
  const pageTitle = getPageTitle(location.pathname);

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200">
      <div className="flex items-center justify-between h-12 px-4 sm:px-6 lg:px-8">
        {/* Hamburger Menu - Flush to left edge */}
        <div className="flex items-center gap-4">
          {!isXL && (
            <SignedIn>
              <button
                onClick={onToggleSidebar}
                className="flex items-center justify-center w-10 h-10 hover:bg-gray-100 rounded transition-colors"
                aria-label="Toggle menu"
              >
                <IonIcon icon={hamIcon} className="text-xl" color="medium" />
              </button>
            </SignedIn>
          )}
        </div>

        {/* Search Bar - Centered */}
        <div className="flex-1 flex items-center justify-center">
          <SignedIn>
            <SearchBar variant="desktop" />
          </SignedIn>
        </div>

        {/* Navigation & Auth */}
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-4">
            <SignedOut>
              <button
                onClick={() => router.push('/sign-in', 'none')}
                className="text-gray-700 hover:text-gray-900 transition-colors"
              >
                Sign In
              </button>
              <button
                onClick={() => router.push('/sign-up', 'none')}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors"
              >
                Sign Up
              </button>
            </SignedOut>

            <SignedIn>
              {/* TODO: Uncomment when Notification Bell feature is implemented
              <NotificationBell variant="desktop" />
              */}

              {/* User Profile */}
              <UserButton>
                <UserButton.MenuItems>
                  <UserButton.Action
                    label="Subscription"
                    labelIcon={<SellIcon sx={{ fontSize: 16 }} />}
                    onClick={() => router.push('/plans', 'none')}
                  />
                  <UserButton.Action
                    label="Billing"
                    labelIcon={<CreditCard sx={{ fontSize: 16 }} />}
                    onClick={() => router.push('/billing', 'none')}
                  />
                </UserButton.MenuItems>
              </UserButton>
            </SignedIn>
          </div>
        </div>
      </div>
    </header >
  );
}

